import { default as _91id_93mFXpUL1YMnMeta } from "/var/www/pages/[lang]/article/[id].vue?macro=true";
import { default as communityLTBWfGhOupMeta } from "/var/www/pages/[lang]/community.vue?macro=true";
import { default as index8w8T3TYZXUMeta } from "/var/www/pages/[lang]/index.vue?macro=true";
import { default as _91id_93DkUGprTTclMeta } from "/var/www/pages/[lang]/tutorial/[id].vue?macro=true";
import { default as tutorialVwc3pKibXxMeta } from "/var/www/pages/[lang]/tutorial.vue?macro=true";
import { default as _91id_93FRjbOJOXoBMeta } from "/var/www/pages/[lang]/updated/[id].vue?macro=true";
import { default as updated5ROTYu1AyfMeta } from "/var/www/pages/[lang]/updated.vue?macro=true";
import { default as _91id_93mrRwWXKHoWMeta } from "/var/www/pages/[lang]/wiki/[id].vue?macro=true";
import { default as wikiQgdECpy4SVMeta } from "/var/www/pages/[lang]/wiki.vue?macro=true";
import { default as indexTNebhwOASsMeta } from "/var/www/pages/index.vue?macro=true";
import { default as healthzUJyHLXiUK6Meta } from "/var/www/pages/manage/healthz.vue?macro=true";
export default [
  {
    name: _91id_93mFXpUL1YMnMeta?.name ?? "lang-article-id",
    path: _91id_93mFXpUL1YMnMeta?.path ?? "/:lang()/article/:id()",
    meta: _91id_93mFXpUL1YMnMeta || {},
    alias: _91id_93mFXpUL1YMnMeta?.alias || [],
    redirect: _91id_93mFXpUL1YMnMeta?.redirect,
    component: () => import("/var/www/pages/[lang]/article/[id].vue").then(m => m.default || m)
  },
  {
    name: communityLTBWfGhOupMeta?.name ?? "lang-community",
    path: communityLTBWfGhOupMeta?.path ?? "/:lang()/community",
    meta: communityLTBWfGhOupMeta || {},
    alias: communityLTBWfGhOupMeta?.alias || [],
    redirect: communityLTBWfGhOupMeta?.redirect,
    component: () => import("/var/www/pages/[lang]/community.vue").then(m => m.default || m)
  },
  {
    name: index8w8T3TYZXUMeta?.name ?? "lang",
    path: index8w8T3TYZXUMeta?.path ?? "/:lang()",
    meta: index8w8T3TYZXUMeta || {},
    alias: index8w8T3TYZXUMeta?.alias || [],
    redirect: index8w8T3TYZXUMeta?.redirect,
    component: () => import("/var/www/pages/[lang]/index.vue").then(m => m.default || m)
  },
  {
    name: tutorialVwc3pKibXxMeta?.name ?? "lang-tutorial",
    path: tutorialVwc3pKibXxMeta?.path ?? "/:lang()/tutorial",
    meta: tutorialVwc3pKibXxMeta || {},
    alias: tutorialVwc3pKibXxMeta?.alias || [],
    redirect: tutorialVwc3pKibXxMeta?.redirect,
    component: () => import("/var/www/pages/[lang]/tutorial.vue").then(m => m.default || m),
    children: [
  {
    name: _91id_93DkUGprTTclMeta?.name ?? "lang-tutorial-id",
    path: _91id_93DkUGprTTclMeta?.path ?? ":id()",
    meta: _91id_93DkUGprTTclMeta || {},
    alias: _91id_93DkUGprTTclMeta?.alias || [],
    redirect: _91id_93DkUGprTTclMeta?.redirect,
    component: () => import("/var/www/pages/[lang]/tutorial/[id].vue").then(m => m.default || m)
  }
]
  },
  {
    name: updated5ROTYu1AyfMeta?.name ?? "lang-updated",
    path: updated5ROTYu1AyfMeta?.path ?? "/:lang()/updated",
    meta: updated5ROTYu1AyfMeta || {},
    alias: updated5ROTYu1AyfMeta?.alias || [],
    redirect: updated5ROTYu1AyfMeta?.redirect,
    component: () => import("/var/www/pages/[lang]/updated.vue").then(m => m.default || m),
    children: [
  {
    name: _91id_93FRjbOJOXoBMeta?.name ?? "lang-updated-id",
    path: _91id_93FRjbOJOXoBMeta?.path ?? ":id()",
    meta: _91id_93FRjbOJOXoBMeta || {},
    alias: _91id_93FRjbOJOXoBMeta?.alias || [],
    redirect: _91id_93FRjbOJOXoBMeta?.redirect,
    component: () => import("/var/www/pages/[lang]/updated/[id].vue").then(m => m.default || m)
  }
]
  },
  {
    name: wikiQgdECpy4SVMeta?.name ?? "lang-wiki",
    path: wikiQgdECpy4SVMeta?.path ?? "/:lang()/wiki",
    meta: wikiQgdECpy4SVMeta || {},
    alias: wikiQgdECpy4SVMeta?.alias || [],
    redirect: wikiQgdECpy4SVMeta?.redirect,
    component: () => import("/var/www/pages/[lang]/wiki.vue").then(m => m.default || m),
    children: [
  {
    name: _91id_93mrRwWXKHoWMeta?.name ?? "lang-wiki-id",
    path: _91id_93mrRwWXKHoWMeta?.path ?? ":id()",
    meta: _91id_93mrRwWXKHoWMeta || {},
    alias: _91id_93mrRwWXKHoWMeta?.alias || [],
    redirect: _91id_93mrRwWXKHoWMeta?.redirect,
    component: () => import("/var/www/pages/[lang]/wiki/[id].vue").then(m => m.default || m)
  }
]
  },
  {
    name: indexTNebhwOASsMeta?.name ?? "index",
    path: indexTNebhwOASsMeta?.path ?? "/",
    meta: indexTNebhwOASsMeta || {},
    alias: indexTNebhwOASsMeta?.alias || [],
    redirect: indexTNebhwOASsMeta?.redirect,
    component: () => import("/var/www/pages/index.vue").then(m => m.default || m)
  },
  {
    name: healthzUJyHLXiUK6Meta?.name ?? "manage-healthz",
    path: healthzUJyHLXiUK6Meta?.path ?? "/manage/healthz",
    meta: healthzUJyHLXiUK6Meta || {},
    alias: healthzUJyHLXiUK6Meta?.alias || [],
    redirect: healthzUJyHLXiUK6Meta?.redirect,
    component: () => import("/var/www/pages/manage/healthz.vue").then(m => m.default || m)
  }
]